import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=4b771782&scoped=true"
import script from "./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b771782",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b771782')) {
      api.createRecord('4b771782', component.options)
    } else {
      api.reload('4b771782', component.options)
    }
    module.hot.accept("./ChangePassword.vue?vue&type=template&id=4b771782&scoped=true", function () {
      api.rerender('4b771782', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/uc/ChangePassword.vue"
export default component.exports